import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';
import logo from '../img/samarsh_logo-removebg-preview.png';
import '@fontsource/manrope';

export default function Headers() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState('');

  const toggleMenu = () => {
    setMenuOpen((prevState) => {
      if (!prevState) {
        setOpenDropdown(''); // Reset dropdown when opening the menu
      }
      return !prevState;
    });
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setOpenDropdown(''); // Reset dropdown when closing the menu
  };

  const handleDropdownToggle = (dropdown) => {
    if (window.innerWidth <= 768) {
      // For mobile, toggle dropdown on click
      setOpenDropdown((prevState) => (prevState === dropdown ? '' : dropdown));
    }
  };

  const handleMouseEnter = (dropdown) => {
    if (window.innerWidth > 768) {
      // For desktop, open dropdown on hover
      setOpenDropdown(dropdown);
    }
  };

  const handleMouseLeave = (e) => {
    if (window.innerWidth > 768) {
      // For desktop, close dropdown when mouse leaves
      const relatedTarget = e.relatedTarget;
      if (
        !relatedTarget ||
        (!e.currentTarget.contains(relatedTarget) && !relatedTarget.closest('.dropdown-menu'))
      ) {
        setOpenDropdown('');
      }
    }
  };

  return (
    <header className="header">
      <div className="logo">
        <img src={logo} alt="Logo" className="logo-image" />
      </div>
      <nav className={`nav-links-container ${menuOpen ? 'show' : ''}`}>
        <ul className="nav-links">
          <li>
            <NavLink to="/home" activeClassName="active" onClick={closeMenu}>
              Home
            </NavLink>
          </li>

          <li>
            <NavLink to="/service" activeClassName="active" onClick={closeMenu}>
              Service
            </NavLink>
          </li>



          {/* <li
            className="dropdown-container"
            onMouseEnter={() => handleMouseEnter('services')}
            onMouseLeave={handleMouseLeave}
            onClick={() => handleDropdownToggle('services')}
          >
            <span>Service</span>
            <ul className={`dropdown-menu ${openDropdown === 'services' ? 'show' : ''}`}>
              <li>
                <NavLink to="/service/services" onClick={closeMenu}>
                  Services
                </NavLink>
              </li>
              <li>
                <NavLink to="/service/service-details" onClick={closeMenu}>
                  Services Detail
                </NavLink>
              </li>
            </ul>
          </li> */}
          <li
            className="dropdown-container"
            onMouseEnter={() => handleMouseEnter('industries')}
            onMouseLeave={handleMouseLeave}
            onClick={() => handleDropdownToggle('industries')}
          >
            <span>Industries</span>
            <ul className={`dropdown-menu ${openDropdown === 'industries' ? 'show' : ''}`}>
              <li>
                <NavLink to="/industrie/industries" onClick={closeMenu}>
                  Industries
                </NavLink>
              </li>
              <li>
                <NavLink to="/industries/industries-details" onClick={closeMenu}>
                  Industries Detail
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <NavLink to="/technology" activeClassName="active" onClick={closeMenu}>
              Technologies
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" activeClassName="active" onClick={closeMenu}>
              Contact
            </NavLink>
          </li>
        </ul>
      </nav>
      <div className="contact-section">
        <span className="contact-number">+91-9552461202</span>
        <button className="contact-us-us">
          Contact Us<span className="arrow">🡥</span>
        </button>
      </div>
      <button className="menu-toggle" onClick={toggleMenu}>☰</button>
    </header>
  );
}
